import { GROUP_MANAGEMENT } from 'constant/RoutesUrls';

export const ACCESS_TOKEN = 'token';
export const ADMIN = '1';
export const SELECTED_LANGUAGE = 'selectedLanguage';

export const VPA_OST_3 = 'VPA Ost 3 (Wien/NÖ/Bgld.)';
export const VPA_OST_2 = 'VPA Ost 2 (Wien/NÖ/Bgld.)';
export const VPA_OST_1 = 'VPA Ost 1 (Wien/NÖ/Bgld.)';
export const UPPER_AUSTRIA = 'Upper Austria';
export const SALZBURG = 'Salzburg';
export const TYROL = 'Tyrol';
export const STYRIA = 'Styria';
export const CARINTHIA = 'Carinthia';
export const VORARLBERG = 'Vorarlberg';

export const WITH_INCOME = 'with_income';
export const WITHOUT_INCOME = 'without_income';
export const APPLICATION_HEALTH_ID = '100104';
export const APPLICATION_EDUCATION_ID = '100103';

export const APPROVED = 'APPROVED';
export const REJECTED = 'REJECTED';
export const PENDING = 'PENDING';
export const FEEDBACK = 'FEEDBACK';
export const UNFROZEN = 'UNFROZEN';

export const INTERNAL_EMPLOYEE = 'INTERNAL_EMPLOYEE';
export const EARLY_RETIREMENT = 'EARLY_RETIREMENT';
export const LEASING_AND_PAYROLLING = 'LEASING_AND_PAYROLLING';
export const ACTIVE_EMPLOYEE = 'ACTIVE_EMPLOYEE';

export const ENGLISH = 'en';
export const GERMAN = 'de';

export const ARCHIVE = 'ARCHIVE';
export const ACTIVE = 'ACTIVE';

export const HEALTH = 'health';
export const EDUCATION = 'education';
export const SCHOOL_ACTIVITY_OF_CHILD = 'school activities of child';

export const HEALTH_ENUM = 'HEALTH';
export const SCHOOL_ACTIVITY_OF_CHILD_ENUM = 'SCHOOL-ACTIVITY-OF-CHILD';

export const REFUNDABLE = 'refundable';
export const CUSTOM_REFUNDABLE = 'custom_refundable';
export const NOT_REFUNDABLE = 'not_refundable';

export const SAP_AGREE = 'sap_agree';
export const SAP_DISAGREE = 'sap_disagree';

export const ACCENDING = 'ASC';
export const DESCENDING = 'DESC';

export const logPerPage = 10;

export enum LogType {
  LOGS = 'logs',
  FORM = 'form'
}

export enum LogInType {
  CRED = 'cred',
  MICROSOFT = 'microsoft'
}

export enum AccountType {
  ADMIN = 'ADMIN',
  USER = 'USER',
  SUPER_ADMIN = 'SUPER_ADMIN'
}

export enum UserPageTab {
  LOGS = 'LOGS'
}

export const ViewAllLimit = 9999999;

export const modules = {
  USERS: {
    view: 'user.view',
    edit: 'user.edit',
    delete: 'user.delete',
    create: 'user.create'
  },
  APPLICATION: {
    view: 'application.view',
    edit: 'application.edit',
    delete: 'application.delete',
    create: 'application.create'
  },
  EVENT: {
    view: 'event.view',
    edit: 'event.edit',
    delete: 'event.delete',
    create: 'event.create'
  },
  TOOLTIP: {
    view: 'tooltip.view',
    edit: 'tooltip.edit',
    delete: 'tooltip.delete',
    create: 'tooltip.create'
  },
  APPLICATION_REQUEST: {
    view: 'application-request.view',
    edit: 'application-request.edit',
    delete: 'application-request.delete',
    create: 'application-request.create'
  },
  APPLICATION_REQUEST_OPTION: {
    view: 'application-type-option.view',
    edit: 'application-type-option.edit',
    delete: 'application-type-option.delete',
    create: 'application-type-option.create'
  },
  PRODUCT: {
    view: 'product.view',
    edit: 'product.edit',
    delete: 'product.delete',
    create: 'product.create'
  },
  ROLE: {
    view: 'role.view',
    edit: 'role.edit',
    delete: 'role.delete',
    create: 'role.create'
  },
  BASIC_DATA: {
    view: 'basic-data.view',
    edit: 'basic-data.edit',
    delete: 'basic-data.delete'
  },
  CONFIGURATION: {
    view: 'subsidy-calculation.view',
    edit: 'subsidy-calculation.edit',
    create: 'subsidy-calculation.create',
    delete: 'subsidy-calculation.delete'
  },
  MAIL: {
    create: 'mail.create',
    view: 'mail.view'
  },
  ADMIN_LEVEL: {
    create: 'admin-configurations.create',
    view: 'admin-configurations.view',
    edit: 'admin-configurations.edit',
    delete: 'admin-configurations.delete'
  },
  GROUP_MANAGEMENT: {
    create: 'admin-configurations.create',
    view: 'admin-configurations.view',
    edit: 'admin-configurations.edit',
    delete: 'admin-configurations.delete'
  },
  FEDERAL_STATE: {
    create: 'admin-configurations.create',
    view: 'admin-configurations.view',
    edit: 'admin-configurations.edit',
    delete: 'admin-configurations.delete'
  },
  FAQ: {
    view: 'faq.view',
    edit: 'faq.edit',
    delete: 'faq.delete',
    create: 'faq.create'
  }
};

export const antrag = 'antrag';

export enum RefundPolicy {
  FULL_OPTIONAL_SV = 'FULL_OPTIONAL_SV',
  CONDITIONAL_SV_ZERO_ALLOWED = 'CONDITIONAL_SV_ZERO_ALLOWED',
  CONDITIONAL_SV_REQUIRED_POSITIVE = 'CONDITIONAL_SV_REQUIRED_POSITIVE',
  NON_REFUNDABLE = 'NON_REFUNDABLE'
}

export enum ApplicationStatusEnums {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  FEEDBACK = 'FEEDBACK',
  FROZEN = 'FROZEN',
  UNFROZEN = 'UNFROZEN'
}

export enum ApplicationEditSection {
  BASIC_DATA = 'basic_data',
  APPLICATION = 'application'
}
